module.exports = __webpack_public_path__ + "static/media/3.43580c5f.png";